import React, {useEffect} from "react";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import {itemApi} from "../../api";
import {useQuery} from "@tanstack/react-query";

const fetchTopProducts = async () => {
    const res = await itemApi.getItems({ limit: 10 });
    const items = res.data.items || res.data;


    const mappedItems = items.map((item) => {
        const sizes = item.variants?.map(v => v.size) || [];
        const coverImage = item.coverImage || item.images?.[0]?.coverImage || "/product-placeholder.png";


        const result = {
            name: item.name,
            slug: item.slug,
            category: item.category,
            totalPrice: item.totalPrice,
            isOutofSale: !item.isStock,
            sizes,
            coverImage
        };


        return result;
    });

    return mappedItems;
};



export default function Shopgram({onLoaded}) {
    const {
        data: products = [],
        isSuccess,
    } = useQuery({
        queryKey: ["top-products"],
        queryFn: fetchTopProducts,
        staleTime: 5 * 60 * 1000,

    });

    useEffect(() => {
        if (isSuccess && products.length > 0) {
            onLoaded?.();
        }
    }, [isSuccess, products]);


    return (
        <section className="flat-spacing-4 pt-0">
            <div className="container">
                <div className="flat-title wow fadeInUp">
                    <h4 className="title">Shop by @Gram</h4>
                </div>
                <Swiper
                    dir="ltr"
                    className="swiper tf-swiper"
                    {...{
                        slidesPerView: 2,
                        spaceBetween: 10,
                        speed: 800,
                        observer: true,
                        observeParents: true,
                        slidesPerGroup: 2,
                        pagination: { el: ".sw-pagination-gallery", clickable: true },
                        breakpoints: {
                            768: { slidesPerView: 3 },
                            1200: { slidesPerView: 5 },
                        },
                    }}
                    modules={[Pagination]}
                >
                    {products.map((item, index) => (
                        <SwiperSlide className="swiper-slide" key={index}>
                            <div
                                className="gallery-item hover-img hover-overlay wow fadeInLeft"
                                data-wow-delay={item.wowDelay}
                            >
                                <div className="image img-style">
                                    <img
                                        src={item.coverImage}
                                        alt={item.alt}
                                        className="lazyload"
                                        width={420}
                                        height={420}
                                    />
                                </div>
                                <Link
                                    to={`/product-detail/${item.slug}`}
                                    className="box-icon hover-tooltip"
                                >
                                    <span className="icon icon-cart2" />
                                    <span className="tooltip">View Product</span>
                                </Link>
                            </div>
                        </SwiperSlide>
                    ))}
                    <span className="d-flex d-xl-none sw-dot-default sw-pagination-gallery justify-content-center" />
                </Swiper>
            </div>
        </section>
    );
}
